module.exports = __webpack_public_path__ + "static/media/planet-yellow.a03d3661.png";